import React from "react";
import { UserID } from "@store/types";
import { State, getUserID } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data<T> = [T, Error | null, boolean];

export function useUserID(email: string): Data<UserID | null> {
  const dispatch = useDispatch();
  const [user_id, error, fetching] = useSelector((state: State) => [
    state.user_ids[email],
    state.network.error.user_ids[email],
    state.network.fetching.user_ids[email],
  ]);
  React.useEffect(() => {
    if (!user_id && !fetching && !error) {
      dispatch(getUserID(email));
    }
  }, [email, dispatch, user_id, error, fetching]);

  return [user_id, error, fetching];
}
